import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { setConnectedUser } from './_store/userStore/user.actions';
import { UserStore } from './core/user/user.types';
import { AppThemeService } from './shared/services/app-theme.service';
import { FuseConfigService } from '../@fuse/services/config';
import { environment } from '../environments/environment';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { MessageNotification } from './shared/models/messageNotification.model';
import { NotificationListenerService } from './shared/services/notification.listner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private readonly _themeService: AppThemeService,
    private _fuseConfigService: FuseConfigService,
    private readonly _store: Store,
    private readonly _notificationListnerService: NotificationListenerService
  ) {}

  ngOnInit(): void {
    this.loadTheme();
    this.trackUser();
    this._notificationListnerService.listenToNotifyer();
  }

  loadTheme() {
    let scheme = localStorage.getItem('scheme') ? localStorage.getItem('scheme') : 'light';
    this._fuseConfigService.config = { scheme };
    let theme = localStorage.getItem('theme') ? localStorage.getItem('theme') : 'default-theme';
    this._fuseConfigService.config = { theme};
    this._themeService.watchScheme();
  }

  trackUser() {
    let response = localStorage.getItem('accessToken');
    if (response) {
      let jwtData = response.split('.')[1];
      let decodedJwtJsonData = window.atob(jwtData);
      let decodedJwtData = JSON.parse(decodedJwtJsonData);
      const connected_user: UserStore = {
        id: decodedJwtData.id,
        email: decodedJwtData.Email,
        fullname: decodedJwtData.name,
        role: decodedJwtData.role,
        status: decodedJwtData.status,
        tenantId: decodedJwtData.TenantId,
        tenant: decodedJwtData.Tenant,
        firstname: decodedJwtData.FirstName,
        lastname: decodedJwtData.LastName,
        enabled: Boolean(decodedJwtData.IsEnabled), // Ensure this is a boolean
        isOnboarded: Boolean(decodedJwtData.IsOnboarded), // Ensure this is a boolean
        audience: decodedJwtData.aud,
        // Optionally set avatar if available in the decoded JWT data
        avatar: decodedJwtData.avatar || undefined // Set avatar if exists, else undefined
      };

    }
  }
}
